import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFigmaComponent } from './simple-icons-figma.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFigmaComponent ],
    exports:      [ SimpleIconsFigmaComponent ],
    bootstrap:    []
})
export class SimpleIconsFigmaModule {}
